<template>
  <div class="login-widget">
    <div class="title">Login</div>
    <input v-model="username" placeholder="Username" type="text" @keyup.enter="submit"><br>
    <input v-model="password" placeholder="Password" type="password" @keyup.enter="submit">
    <div class="message">{{message}}</div>
  </div>
</template>

<script>
import http from 'axios'

export default {
  data () {
    return {
      username: '',
      password: '',
      message:  ''
    }
  },
  methods: {
    submit () {
      http.post('/accesscontrol/login', undefined, {auth: {
        username: this.username,
        password: this.password
      }})
      .then(response => {
        console.log('Login OK', this.username)
        this.message = 'Login OK'
        this.$router.push('/infobits')
      })
      .catch(error => {
        console.log('Login failed', error)
        this.message = 'Login failed'
      })
    }
  }
}
</script>
<style>
.login-widget .message,
.login-widget .title,
.login-widget {
  margin: auto;
  text-align: center;
  padding: 1em;
  font-size: 20px;
}

.login-widget .message {
  margin-top: 1em;
}

.login-widget input {
  padding: .5em;
}
</style>



// WEBPACK FOOTER //
// login-page.vue?2e019d83